import styled from 'styled-components'

export const Container = styled.div`
  display: flex;
  justify-content: center;
  height: 3rem;
  margin-top: 1rem;
  margin-bottom: 1rem;
  box-sizing: border-box;
`
